<div class="flex gap-2">
    <div class="input-field" style="width: 250px;">
        <label for="dateFrom">Fecha desde *</label>
        <p-calendar [(ngModel)]="filters.dateFrom" [firstDayOfWeek]="1" [showIcon]="true" [showTime]="false"
            [hourFormat]="'24'" dateFormat="dd/mm/yy" appendTo="body" inputId="dateFrom" class="w-full"></p-calendar>
    </div>
    <div class="input-field" style="width: 250px;">
        <label for="dateTo">Fecha hasta *</label>
        <p-calendar [(ngModel)]="filters.dateTo" [firstDayOfWeek]="1" [showIcon]="true" [showTime]="false"
            [hourFormat]="'24'" dateFormat="dd/mm/yy" appendTo="body" inputId="dateTo" class="w-full"></p-calendar>
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="companyId">Compañía *</label>
        <p-dropdown [(ngModel)]="filters.companyId" [options]="companies" optionLabel="name" optionValue="id"
            placeholder="Selecciona una compañía" [filter]="true" filterBy="name" appendTo="body" inputId="companyId"
            class="w-full" (onChange)="onCompanyChange()"></p-dropdown>
    </div>
    <div class="input-field" style="width: 220px;">
        <label for="contractId">Contrato *</label>
        <p-dropdown [(ngModel)]="filters.contractId" [options]="contracts" optionLabel="name" optionValue="id"
            placeholder="Selecciona un contrato" [filter]="true" filterBy="name" appendTo="body" inputId="contractId"
            class="w-full" [disabled]="!filters.companyId" (onChange)="onContractChange()"></p-dropdown>
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="name">Nombre</label>
        <input pInputText [(ngModel)]="filters.name" id="name" class="w-full" />
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="phone">Teléfono</label>
        <input pInputText [(ngModel)]="filters.phone" id="phone" class="w-full" />
    </div>
    <div class="input-field" style="width: 150px;">
        <label for="email">Email</label>
        <input pInputText [(ngModel)]="filters.email" id="email" class="w-full" />
    </div>
    <div class="input-field">
        <label for="email">&nbsp;</label>
        <div class="flex gap-2">
            <button pButton label="Buscar" icon="pi pi-search" (click)="search()" [loading]="loading"></button>
        </div>
    </div>
</div>

<p-table [value]="cases" [selection]="selectedCases" (selectionChange)="onSelectionChange($event)" dataKey="id" [lazy]="true"
    (onLazyLoad)="loadData($event)" [loading]="loading" [paginator]="true" [rows]="25" [totalRecords]="totalRecords"
    [rowsPerPageOptions]="[25, 50, 100]" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} registros"
    styleClass="mt-3" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 48px;">
                <p-checkbox inputId="selectAllCases" [binary]="true" [ngModel]="areAllCasesSelected()"
                    [disabled]="loading || totalRecords === 0"
                    (ngModelChange)="toggleAllCasesSelection($event)"></p-checkbox>
            </th>
            <th>Fecha</th>
            <th>Número de expediente</th>
            <th>Estado</th>
            <th>Nombre cliente</th>
            <th>NIF cliente</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-case>
        <tr>
            <td>
                <p-tableCheckbox [value]="case"></p-tableCheckbox>
            </td>
            <td>{{ case.caseDate | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
            <td>{{ case.caseNumber }}</td>
            <td>
                <span class="p-tag" [style.backgroundColor]="case.caseState?.backgroundColor"
                    [style.color]="case.caseState?.foregroundColor">
                    {{ case.caseState?.name }}
                </span>
            </td>
            <td>{{ case.client?.name }}</td>
            <td>{{ case.client?.vatNumber }}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="6">No hay expedientes para mostrar</td>
        </tr>
    </ng-template>
</p-table>

<div class="data-protection-footer">
    <button pButton label="Eliminar seleccionados" icon="pi pi-trash" severity="danger"
    (click)="confirmDeleteSelected()" [disabled]="!allowWrite || getSelectedRecordsCount() === 0 || deleting"
        [loading]="deleting"></button>
</div>

<p-dialog header="Eliminación por protección de datos" [(visible)]="showDeleteDialog" [modal]="true"
    [closable]="!deleting" [draggable]="false" [resizable]="false" [style]="{ width: '900px', maxWidth: '95vw' }">
    <div class="data-protection-dialog">
        <div class="data-protection-dialog__summary">
            Se aplicará la solicitud sobre {{ getSelectedRecordsCount() }} expedientes seleccionados.
        </div>

        <div class="input-field">
            <label for="deleteReason">Razón de la solicitud</label>
            <textarea pInputTextarea id="deleteReason" [(ngModel)]="deleteRequest.reason" rows="3"
                class="w-full"></textarea>
        </div>

        <div class="data-protection-block">
            <h4>Datos personales</h4>
            <div class="data-protection-checks">
                <div class="data-protection-check" *ngFor="let option of personalDataOptions">
                    <p-checkbox [inputId]="'personal-' + option.key" [ngModel]="getPersonalDataValue(option.key)"
                        (ngModelChange)="setPersonalDataValue(option.key, $event)" [binary]="true"></p-checkbox>
                    <label [for]="'personal-' + option.key">{{ option.label }}</label>
                </div>
            </div>
        </div>

        <div class="data-protection-block">
            <h4>Documentos adjuntos</h4>
            <div class="data-protection-checks">
                <div class="data-protection-check" *ngFor="let option of attachmentOptions">
                    <p-checkbox [inputId]="'attachment-' + option.key" [ngModel]="getAttachmentValue(option.key)"
                        (ngModelChange)="setAttachmentValue(option.key, $event)" [binary]="true"></p-checkbox>
                    <label [for]="'attachment-' + option.key">{{ option.label }}</label>
                </div>
            </div>
        </div>

        <div class="data-protection-block">
            <h4>Eventos</h4>
            <div class="data-protection-checks">
                <div class="data-protection-check" *ngFor="let option of eventOptions">
                    <p-checkbox [inputId]="'event-' + option.key" [ngModel]="getEventValue(option.key)"
                        (ngModelChange)="setEventValue(option.key, $event)" [binary]="true"></p-checkbox>
                    <label [for]="'event-' + option.key">{{ option.label }}</label>
                </div>
            </div>
        </div>

        <div class="data-protection-block">
            <h4>Documentos</h4>
            <div class="data-protection-checks">
                <div class="data-protection-check" *ngFor="let option of retentionOptions">
                    <p-checkbox [inputId]="'retention-' + option.key" [ngModel]="getRetentionValue(option.key)"
                        (ngModelChange)="setRetentionValue(option.key, $event)" [binary]="true"></p-checkbox>
                    <label [for]="'retention-' + option.key">{{ option.label }}</label>
                </div>
            </div>
        </div>

        <div class="data-protection-confirmation">
            <p-checkbox inputId="confirmPermanentDeletion" [(ngModel)]="deleteRequest.confirmPermanentDeletion"
                [binary]="true"></p-checkbox>
            <label for="confirmPermanentDeletion">
                Soy consciente de que los datos no podrán ser recuperados y serán borrados permanentemente.
            </label>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" severity="secondary" icon="pi pi-times" (click)="closeDeleteDialog()"
            [disabled]="deleting"></button>
        <button pButton label="Eliminar" severity="danger" icon="pi pi-trash" (click)="submitDeleteDialog()"
            [disabled]="!allowWrite || deleting || !deleteRequest.confirmPermanentDeletion" [loading]="deleting"></button>
    </ng-template>
</p-dialog>